import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { alunos_turma } from "../../services/api";

const Alunos_turma = (props) => {

    let cod_unidade = props.un;
    const [dataTotal, setDataTotal] = useState([]);

    const fetchData = async () => {
        try {
            const response = await alunos_turma(cod_unidade);
            setDataTotal(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    let chartData = [];
    /*
        {
            "turma": "10111",
            "total": "7",
            "novos": "7",
            "renovados": "0"
        },
    
    */

    if (typeof dataTotal !== 'undefined' && dataTotal !== null) {
        chartData = dataTotal.map((item) => {
            const novos = parseInt(item.novos) || 0;
            const renovados = parseInt(item.renovados) || 0;
            const total = parseInt(item.total) || 1; // Prevent division by zero

            // Calculate percentages for the bar width
            const pctNovos = (novos / total) * 100;
            const pctRenovados = (renovados / total) * 100;

            // Create the HTML string for the bar
            // Blue for 'Novos', Red for 'Renovados'
            const barHtml = `
                <div style="display: flex; width: 120px; height: 16px; border: 1px solid #ccc; background-color: #f1f1f1;">
                    <div style="width: ${pctNovos}%; background-color: #2196F3;" title="Novos: ${novos} (${pctNovos.toFixed(0)}%)"></div>
                    <div style="width: ${pctRenovados}%; background-color: #F44336;" title="Renovados: ${renovados} (${pctRenovados.toFixed(0)}%)"></div>
                </div>
            `;

            const row = [item.turma];
            row.push(novos);
            row.push(renovados);
            row.push(parseInt(item.total));
            row.push(barHtml); // Add the HTML string as the last column
            return row;
        });
    }

    // Update header to include the new column
    chartData.unshift(['TURMA', 'NOVOS', 'RENOVADOS', 'TOTAL', 'PROPORÇÃO']);

    const options = {
        allowHtml: true, // Crucial for rendering the bar
        page: 'enable',
        pageSize: 15,
        cssClassNames: {
            // Optional: Helps with vertical alignment if the bars look off
            tableCell: 'google-chart-cell'
        }
    };

    let formatters = [
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 20000, "blue", "white"],
            ],
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 20000, "red", "white"],
            ],
        },
    ];


    return (
        <div className="alunos_turma">
            <center>
                <h2>Alunos por turma</h2>
                <Chart
                    chartType="Table"
                    version="current"
                    width="100%"
                    height="500px"
                    data={chartData}
                    options={options}
                    formatters={formatters}
                />
            </center>
            <style>{`
                .google-chart-cell {
                    vertical-align: middle !important;
                }
            `}</style>
        </div>
    );
}
export default Alunos_turma;